<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>마이페이지</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">마이페이지</p>
          <ul class="depth">
            <li>
              <router-link to="/map" title="공영주차장">공영주차장</router-link>
            </li>
            <li>
              <router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link>
            </li>
            <li>
              <router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link>
            </li>
            <li>
              <router-link to="/periodinfo" title="주차서비스">주차서비스</router-link>
            </li>
            <li>
              <router-link to="/noticelist" title="정보마당">정보마당</router-link>
            </li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">회원정보</p>
          <ul class="depth">
            <li>
              <router-link to="/mypagemain" title="회원정보">회원정보</router-link>
            </li>
            <li>
              <router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link>
            </li>
            <li>
              <router-link to="/mypagediscountpayment" title="웹 선불권 이용내역">웹 선불권 이용내역</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">회원정보 변경</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table mypage">
            <table>
              <caption>
                회원정보 변경 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 90px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">아이디</th>
                  <td>{{ empNo }}</td>
                </tr>
                <tr>
                  <th scope="row">성명</th>
                  <td>{{ empNm }}</td>
                </tr>
                <tr>
                  <th scope="row">변경 비밀번호</th>
                  <td>
                    <input
                      type="password"
                      title="변경할 비밀번호 입력"
                      placeholder="영문,숫자,특수문자 조합 8-20자리"
                      v-model="password"
                    />
                    <div class="error" v-if="pwReqChk">필수 입력란입니다.</div>
                    <div class="error" v-if="pwMinChk">8~20자리 입력란입니다.</div>
                    <div class="error" v-if="pwMaxChk">8~20자리 입력란입니다.</div>
                    <div class="error" v-if="pwRegexChk">조건에 맞지 않습니다. ※ 숫자,영문자,특수문자 (8~20자리)</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input type="password" title="비밀번호 재입력" v-model="passwordCon" />
                    <div class="error" v-if="pwConReqChk">필수 입력란입니다.</div>
                    <div class="error" v-if="pwConSameChk">일치하지 않는 비밀번호입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대전화</th>
                  <td>
                    <div class="tell">
                      <input
                        type="text"
                        title="사업자 휴대폰 식별번호 선택"
                        v-model="firstPhoneNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="휴대폰 앞 4자리 입력"
                        v-model="secondPhoneNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="휴대폰 뒤 4자리 입력"
                        v-model="lastPhoneNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                    <div class="error" v-if="firstPhoneNumberChk || secondPhoneNumberChk || lastPhoneNumberChk">
                      필수 입력란입니다.
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">전화번호</th>
                  <td>
                    <div class="tell">
                      <input
                        type="text"
                        maxlength="4"
                        title="전화번호 국번 입력"
                        v-model="firstTelNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="전화번호 앞 4자리 입력"
                        v-model="secondTelNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="전화번호 뒤 4자리 입력"
                        v-model="lastTelNumber"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                    <div class="error" v-if="firstTelNumberChk || secondTelNumberChk || lastTelNumberChk">
                      필수 입력란입니다.
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <div class="flex wrap">
                      <div>
                        <input type="text" title="차량번호 입력" @keyup.enter="chkIrs" v-model="carNo" />
                        <div class="error" v-if="carNoChk">필수 입력란입니다.</div>
                      </div>
                      <input
                        v-model="discountNm"
                        title="할인 입력"
                        type="text"
                        class="w230"
                        disabled
                        @keydown.enter="chkIrs"
                      />
                      <button :disabled="isLoading" v-if="isLoading" class="btn gray"><LoadingSpinner /></button>
                      <button :disabled="isLoading" v-if="!isLoading" type="button" class="btn gray" @click="chkIrs">
                        할인적용확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량 소유주명</th>
                  <td>
                    <input type="text" title="차량 소유주명 입력" v-model="carOwnerNm" />
                    <div class="error" v-if="carOwnerNmChk">필수 입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차종</th>
                  <td>
                    <input type="text" title="차종 입력" v-model="carKind" />
                    <div class="error" v-if="carKindChk">필수 입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td colspan="3">
                    <div class="address">
                      <div class="flex">
                        <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                        <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                      </div>
                      <div class="flex">
                        <input type="text" title="주소 입력" v-model="addr" readonly />
                        <input type="text" title="상세주소 입력" v-model="addrDetail" />
                      </div>
                      <div class="error" v-if="addrChk || zipcodeChk">필수 입력란입니다.</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">지정 주차장</th>
                  <td>
                    <p>{{ parkingNm }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea">
          <button type="button" class="btn mint" @click="secessionBtn">회원탈퇴</button>
          <button type="button" class="btn gray" @click="$router.push('/mypagemain')">취소</button>
          <button type="button" class="btn blue" @click="modifyModal">정보변경</button>
        </article>
      </div>
    </section>

    <!-- 회원탈퇴 -->
    <popup v-if="idShow">
      <template #info> 회원탈퇴</template>
      <template #content>
        <article class="paragraph">
          <p>회원을 탈퇴 하시겠습니까?</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                회원탈퇴 테이블
              </caption>
              <colgroup>
                <col style="width: 25%; min-width: 80px" />
                <col style="width: 75%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">비밀번호</th>
                  <td>
                    <input type="password" v-model="checkPw" title="비밀번호 입력" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input type="password" v-model="checkPwCon" title="비밀번호 재입력" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn gray" @click="CancleBtn">취소</button>
          <button class="btn blue" @click="deleteMember">탈퇴</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>

    <!-- 알럿 -->
    <alert v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg1 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="infoModify">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert>
    <alert v-show="updateSuccess">
      <template #content>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="updateDone">확인</button>
        </article>
      </template>
    </alert>

    <zip-code v-if="showModal">
      <template #info> 우편번호</template>
      <template #content>
        <article>
          <VueDaumPostcode @complete="searchedAddress" />
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </zip-code>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import Popup from '../../../components/PopupType1.vue';
import Alert from '../../../components/Alert01.vue';
import { required, sameAs, helpers, minLength, maxLength } from 'vuelidate/lib/validators';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';

const passRegex = helpers.regex('passRegex', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
import zipCode from '../../../components/PopupType1.vue';
import { VueDaumPostcode } from 'vue-daum-postcode';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      updateSuccess: false,
      msg1: '정보를 변경 하시겠습니까?',
      msg2: '정보가 변경 되었습니다.',
      idShow: false,
      showModal: false,

      empNo: '',
      empNm: '',
      empEsntlId: '',
      applyMobile: '',
      applyAddr: '',
      carOwnerNm: '',
      carNo: '',
      carKind: '',
      firstPhoneNumber: '',
      secondPhoneNumber: '',
      lastPhoneNumber: '',
      firstTelNumber: '',
      secondTelNumber: '',
      lastTelNumber: '',
      zipcode: '',
      addr: '',
      addrDetail: '',

      password: '',
      passwordCon: '',
      checkPw: '',
      checkPwCon: '',
      isLoading: false,

      discountCode: '',
      discountNm: '',
      temp: '',

      parkingNm: '',

      pwReqChk: false,
      pwRegexChk: false,
      pwMaxChk: false,
      pwMinChk: false,
      pwConReqChk: false,
      pwConSameChk: false,
      carOwnerNmChk: false,
      carKindChk: false,
      carNoChk: false,
      zipcodeChk: false,
      addrChk: false,
      firstPhoneNumberChk: false,
      secondPhoneNumberChk: false,
      lastPhoneNumberChk: false,
      firstTelNumberChk: false,
      secondTelNumberChk: false,
      lastTelNumberChk: false,
    };
  },

  validations: {
    password: {
      minLength: minLength(8),
      maxLength: maxLength(20),
      passRegex: passRegex,
    },
    passwordCon: {
      sameAsPassword: sameAs('password'),
    },
    carKind: {
      required,
    },
    carOwnerNm: {
      required,
    },
    carNo: {
      required,
    },
    zipcode: {
      required,
    },
    addr: {
      required,
    },
    firstPhoneNumber: {
      minLength: minLength(3),
    },
    secondPhoneNumber: {
      minLength: minLength(3),
    },
    lastPhoneNumber: {
      minLength: minLength(3),
    },
    firstTelNumber: {
      minLength: minLength(2),
    },
    secondTelNumber: {
      minLength: minLength(3),
    },
    lastTelNumber: {
      minLength: minLength(3),
    },
  },

  components: {
    Popup,
    Alert,
    zipCode,
    VueDaumPostcode,
    LoadingSpinner,
  },

  created() {
    const check = this.$route.query.check;
    if (!check) {
      alert('잘못된 접근입니다.');
      this.$router.push('/mypagemain');
      return;
    }
    this.empNo = this.$store.state.empNo;
    this.getMemberInfo();
  },

  methods: {
    async chkIrs() {
      this.isLoading = true;
      if (this.carNo == undefined || this.carOwnerNm == undefined) {
        alert('차량번호와 소유주를 입력한 후 시도해주세요.');
        this.isLoading = false;
        return;
      }
      const res = await axios('get', '/api/reduction/irs.json', {
        carNo: this.carNo,
        carOwnerNm: this.carOwnerNm,
      });
      const data = res.data.value;
      if (data.dcList == 0) {
        alert('다른 감면 혜택없이 일반으로 적용됩니다.');
        this.discountCode = 'DC001';
        this.discountNm = '일반';
      } else {
        this.discountCode = data.dcList[0].dcCode;
        this.discountNm = data.dcList[0].note;
      }
      this.temp = this.carNo;
      this.isLoading = false;
    },
    CancleBtn() {
      this.idShow = false;
      this.showModalMsgSuccess = false;
      this.showModal = false;
      this.checkPw = '';
      this.checkPwCon = '';
    },

    CloseBtn() {
      this.idShow = false;
      this.showModalMsgSuccess = false;
      this.checkPw = '';
      this.checkPwCon = '';
    },

    updateDone() {
      this.showModalMsgSuccess = false;
      (this.pwReqChk = false),
        (this.pwRegexChk = false),
        (this.pwMaxChk = false),
        (this.pwMinChk = false),
        (this.pwConReqChk = false),
        (this.pwConSameChk = false),
        (this.carOwnerNmChk = false),
        (this.carKindChk = false),
        (this.carNoChk = false),
        (this.zipcodeChk = false),
        (this.addrChk = false),
        (this.firstPhoneNumberChk = false),
        (this.secondPhoneNumberChk = false),
        (this.lastPhoneNumberChk = false),
        (this.firstTelNumberChk = false),
        (this.secondTelNumberChk = false),
        (this.lastTelNumberChk = false),
        this.getMemberInfo();
      this.$store.state.zipcode = this.zipcode;
      this.$store.state.addr = this.addr;
      this.$store.state.addrDetail = this.addrDetail;
      this.$store.state.empCarNo = this.carNo ? this.carNo.replace(/\s/gi, '') : '';
      this.$store.state.empMobile = this.firstPhoneNumber + this.secondPhoneNumber + this.lastPhoneNumber;
      this.updateSuccess = false;
    },

    daumPostcodeBtn() {
      this.showModal = true;
    },

    secessionBtn() {
      this.idShow = true;
    },

    getPhoneNums(phoneNums) {
      this.firstPhoneNumber = phoneNums.substr(0, 3);
      this.secondPhoneNumber = phoneNums.substr(3, 4);
      this.lastPhoneNumber = phoneNums.substr(7, 4);
    },
    searchedAddress(data) {
      this.zipcode = data.zonecode;
      if (data.userSelectedType == 'R') {
        this.addr = data.address;
      } else {
        this.addr = data.jibunAddress;
      }
      this.showModal = false;
    },

    async getMemberInfo() {
      const res = await axios('get', '/api/member/view', {
        applyId: this.empNo,
      });
      const {
        carKind = '',
        carOwnerNm = '',
        carNo = '',
        empMobile = '',
        zipcode = '',
        address = '',
        addressDetail = '',
        empNm = '',
        empEsntlId = '',
        empTelNo = '',
        discountCd = '',
        discountNm = '',
        parkingNm = '',
      } = res.data.result;

      (this.carOwnerNm = carOwnerNm),
        (this.carNo = carNo),
        (this.carKind = carKind),
        (this.discountCd = discountCd),
        (this.discountNm = discountNm),
        (this.parkingNm = parkingNm);
      if (empMobile != null) {
        this.getPhoneNums(empMobile);
      }
      if (empTelNo != null) {
        if (empTelNo.length == 10) {
          if (empTelNo.slice(0, 2) == '02') {
            this.firstTelNumber = empTelNo.slice(0, 2);
            this.secondTelNumber = empTelNo.slice(2, 6);
            this.lastTelNumber = empTelNo.slice(6, empMobile.length);
          } else {
            this.firstTelNumber = empTelNo.slice(0, 3);
            this.secondTelNumber = empTelNo.slice(3, 6);
            this.lastTelNumber = empTelNo.slice(6, empMobile.length);
          }
        } else {
          if (empTelNo.slice(0, 2) == '02') {
            this.firstTelNumber = empTelNo.slice(0, 2);
            this.secondTelNumber = empTelNo.slice(2, 5);
            this.lastTelNumber = empTelNo.slice(5, empMobile.length);
          } else {
            this.firstTelNumber = empTelNo.slice(0, 3);
            this.secondTelNumber = empTelNo.slice(3, 7);
            this.lastTelNumber = empTelNo.slice(7, empMobile.length);
          }
        }
      }
      this.zipcode = zipcode;
      this.addr = address;
      this.addrDetail = addressDetail;
      this.applyMobile = empMobile;
      this.empNm = empNm;
      this.empEsntlId = empEsntlId;
    },

    modifyModal() {
      if (this.$v.$invalid) {
        if (!this.$v.password.passRegex) this.pwRegexChk = true;
        if (!this.$v.password.maxLength) this.pwMaxChk = true;
        if (!this.$v.password.minLength) this.pwMinChk = true;
        if (!this.$v.passwordCon.sameAsPassword) this.pwConSameChk = true;
        if (!this.$v.carNo.required) this.carNoChk = true;
        if (!this.$v.carKind.required) this.carKindChk = true;
        if (!this.$v.carOwnerNm.required) this.carOwnerNmChk = true;
        if (!this.$v.zipcode.required) this.zipcodeChk = true;
        if (!this.$v.addr.required) this.addrChk = true;
        if (!this.$v.firstPhoneNumber.minLength) this.firstPhoneNumberChk = true;
        if (!this.$v.secondPhoneNumber.minLength) this.secondPhoneNumberChk = true;
        if (!this.$v.lastPhoneNumber.minLength) this.lastPhoneNumberChk = true;
        if (!this.$v.firstTelNumber.minLength) this.firstTelNumberChk = true;
        if (!this.$v.secondTelNumber.minLength) this.secondTelNumberChk = true;
        if (!this.$v.lastTelNumber.minLength) this.lastTelNumberChk = true;
        return;
      }
      this.showModalMsgSuccess = true;
    },

    async infoModify() {
      if (this.temp != this.carNo && this.temp != '') {
        this.chkIrs();
      }
      const apiParams = new FormData();
      apiParams.append('applyId', this.empNo);
      apiParams.append('empMobile', this.firstPhoneNumber + this.secondPhoneNumber + this.lastPhoneNumber);
      apiParams.append('empTelNo', this.firstTelNumber + this.secondTelNumber + this.lastTelNumber);
      apiParams.append('carOwnerNm', this.carOwnerNm);
      apiParams.append('carNo', this.carNo.replace(/\s/gi, ''));
      apiParams.append('carKind', this.carKind);
      apiParams.append('password', this.password);
      apiParams.append('zipcode', this.zipcode);
      apiParams.append('address', this.addr);
      apiParams.append('addressDetail', this.addrDetail);
      apiParams.append('empEsntlId', this.empEsntlId);
      apiParams.append('discountCd', this.discountCode);

      const res = await axios('post', '/api/member/update', apiParams);
      if (res.data) {
        this.$store.commit('empMobile', this.applyMobile);
        this.$store.commit('empCarNo', this.carNo.replace(/\s/gi, ''));
        this.$store.commit('zipcode', this.zipcode);
        this.$store.commit('addr', this.addr);
        this.$store.commit('addrDetail', this.addrDetail);
        this.updateSuccess = true;
      }
    },

    async deleteMember() {
      if (this.checkPw === this.checkPwCon) {
        const res = await axios('post', '/api/member/pw-check', null, {
          params: {
            empNo: this.empNo,
            password: this.checkPw,
          },
        });
        const data = res.data;
        if (!data.result) {
          alert('잘못된 비밀번호입니다.');
          return;
        }
        let apiParms = new FormData();
        apiParms.set('empNo', this.empNo);
        await axios('post', '/api/member/delete', apiParms);
        await axios('post', '/api/actionLogout.json');
        this.$store.dispatch('logout', null);
        this.$router.push('/main');
      } else {
        alert('두 비밀번호가 일치하지 않습니다.');
      }
    },
  },
};
</script>
